module.exports = __webpack_public_path__ + "img/attack_icepilar.9a4fd6d4.png";